<div class="container-fluid" appPadding>
  <div class="row">
    <div class="col">
      <form (submit)="onSave()" #f="ngForm">
        <div class="row">
          <div class="col">
            <fieldset>
              <legend><h4>Monitoring</h4></legend>
              <mat-checkbox [(ngModel)]="isSentryActive" matTooltip="When enabled, Sentry will capture and monitor application errors." name="sentry_kill_switch">
                Enable Sentry Monitoring
              </mat-checkbox>
              <mat-hint>When enabled, Sentry will capture and monitor application errors.</mat-hint>
            </fieldset>
            <fieldset class="mt-3">
              <legend><h4>Super Admin Quick Access</h4></legend>
              <mat-form-field appearance="outline">
                <mat-label>Quick Access Inactivity Timeout</mat-label>
                <mat-select [(ngModel)]="quickAccessDurationHours" name="quick_access_duration_hours" required>
                  <mat-option *ngFor="let h of quickAccessHourOptions" [value]="h">{{ h }} {{ h === 1 ? 'hour' : 'hours' }}</mat-option>
                </mat-select>
              </mat-form-field>
              <br>
              <mat-hint>Sessions are also hard-capped at 72 hours from creation regardless of activity.</mat-hint>
            </fieldset>
            <fieldset class="mt-3">
              <legend><h4>Account Membership Approvals</h4></legend>
              <mat-checkbox [(ngModel)]="accountLinkApprovalsEnabled" name="account_link_approvals_enabled"
                            matTooltip="When enabled, a user who registers into or selects an existing account must be approved by that account before they can see its information.">
                Require approval to join an existing account
              </mat-checkbox>
              <br>
              <mat-hint>
                When enabled, registering with or selecting an existing company name raises a request for
                that account to approve, and the user works on their own account until it is granted.
                Accounts a user creates themselves are unaffected. This does not change existing
                memberships, only new requests from now on.
              </mat-hint>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="mt-3" mat-raised-button color="primary" [disabled]="!f.valid || inProgress">
              <mat-icon>save</mat-icon>
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
